import { ModalStore } from '../types/modals'
import { create } from 'zustand'

const useModalStore = create<ModalStore>((set, get) => ({
    // initial value: no modal open
    currentModal: null,

    // actions
    openModal: (key) => {
        set(() => ({ currentModal: key }))
    },
    closeModal: () => {
        set(() => ({ currentModal: null }))
    },
    toggleModal: (key) =>
        set((state) => ({
            currentModal: state.currentModal === key ? null : key,
        })),
    isModalOpen: (key) => get().currentModal === key
}))

export { useModalStore }
